import React from 'react';
import Header from './components/Header';
import HeroSimple from './components/Hero';
import './index.css';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSimple />
    </div>
  );
}

export default App;
